<template>
  <div class="p-3">
    <div class="">
      <div class="text-right">
        <b-button variant="danger" size="sm" @click="removeQuestion">
          Remove
        </b-button>
      </div>
      <div>
        <b-form-group label="Question Text">
          <b-form-input
            v-model="question.text"
            placeholder="Enter question text"
            required
          ></b-form-input>
        </b-form-group>
      </div>
    </div>

    <b-form-group label="Question Type">
      <b-form-select
        v-model="question.question_type"
        :options="questionTypes"
        required
      ></b-form-select>
    </b-form-group>
    
    <b-form-group label="Question Point(s)">
      <b-form-input
        v-model="question.points"
        type="number"
        placeholder="Enter points for the question"
        required
      ></b-form-input>
    </b-form-group>

    <!-- Options for Multiple Choice -->
    <div v-if="question.question_type === 'multiple-choice'">
      <h6>Options</h6>

      <!-- Input to add a new option -->
      <div class="d-flex align-items-center mb-3">
        <b-form-input
          v-model="newOption"
          placeholder="Enter question option"
          class="mr-2"
        ></b-form-input>
        <b-button size="sm" @click="addOption">Add</b-button>
      </div>

      <!-- List of options with radio to select answer -->
      <div
        v-for="(option, optIndex) in question.options"
        :key="optIndex"
        class="d-flex align-items-center mb-2"
      >
        <b-form-radio
          v-model="question.answer"
          :value="option"
          class="mr-2"
          name="answer"
        ></b-form-radio>
        <b-form-input :value="option" disabled class="mr-2"></b-form-input>
        <b-button variant="danger" size="sm" @click="removeOption(optIndex)">
          Remove
        </b-button>
      </div>

      <div class="mt-3">
        <strong>Selected Answer:</strong> {{ question.answer }}
      </div>
    </div>

    <!-- for identification -->
    <div v-if="question.question_type === 'identification'">
      <h6>Answer</h6>
      <b-form-input
        v-model="question.answer"
        placeholder="Enter answer"
        required
      ></b-form-input>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    question: {
      type: Object,
      required: true,
    },
    questionTypes: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      newOption: "",
    };
  },
  methods: {
    removeQuestion() {
      this.$emit("remove");
    },
    addOption() {
      if (this.newOption.trim()) {
        this.question.options.push(this.newOption.trim());
        this.newOption = "";
      }
    },
    removeOption(optIndex) {
      this.question.options.splice(optIndex, 1);
    },
  },
};
</script>
